import BaseElements from './Base'

export default function install(Vue) {
  Vue.use(BaseElements)
}
